import { getAllTrains } from "api/trains";
import { getUnitsByTrainId } from "api/units";

const assetsSelectsConfig = {
  getAllTrains,
  getUnitsByTrainId
};

export default assetsSelectsConfig;